import { junkMessageHeader, junkMessageBody } from './markAsJunkService.locstring.json';
import loc from 'owa-localize';
import getServiceItemIds from './utils/getServiceItemIds';
import MarkAsJunkRequest from 'owa-service/lib/contract/MarkAsJunkRequest';
import MarkAsJunkResponseMessage from 'owa-service/lib/contract/MarkAsJunkResponseMessage';
import markAsJunkRequest from 'owa-service/lib/factory/markAsJunkRequest';
import markAsJunkOperation from 'owa-service/lib/operation/markAsJunkOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Configure the mark as junk/not junk request Body
 * @param itemIdsToUpdate an array of the item id strings to be updated
 * @param isJunk whether it is a mark as junk action or not
 * @return the request body for mark as junk service request
 */
function configureRequestBody(itemIdsToUpdate: string[], isJunk: boolean): MarkAsJunkRequest {
    const markAsJunkRequestData = {
        ItemIds: getServiceItemIds(itemIdsToUpdate),
        IsJunk: isJunk,
        MoveItem: true,
        SendCopy: false,
        JunkMessageHeader: loc(junkMessageHeader),
        JunkMessageBody: loc(junkMessageBody),
    };

    return markAsJunkRequest(markAsJunkRequestData);
}

/**
 * Submit the mark as junk service request
 * @param itemIds the item ids to be updated
 * @param isJunk whether it is a mark as junk action or not
 * @return the MarkAsJunkResponseMessage
 */
export default function markConversationAsJunkService(
    itemIdsToUpdate: string[],
    isJunk: boolean
): Promise<MarkAsJunkResponseMessage> {
    const requestBody = configureRequestBody(itemIdsToUpdate, isJunk);

    return markAsJunkOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
